(function() {
  var drawer, overlay, settings;

  function init() {
    drawer = document.getElementById('dogal-cart-drawer');
    overlay = document.getElementById('dogal-cart-overlay');
    settings = window.CART_DRAWER_SETTINGS || {};
    if (!drawer || !overlay) return;

    overlay.addEventListener('click', CartDrawer.close);
    var closeBtn = document.getElementById('dogal-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', CartDrawer.close);
  }

  window.CartDrawer = {
    open: function() {
      if (!drawer) init();
      if (!drawer) return;
      overlay.style.display = 'block';
      requestAnimationFrame(function() {
        overlay.style.opacity = '1';
        drawer.style.transform = 'translateX(0)';
      });
      CartDrawer.refresh();
    },

    close: function() {
      if (!drawer) return;
      overlay.style.opacity = '0';
      drawer.style.transform = 'translateX(100%)';
      setTimeout(function() { overlay.style.display = 'none'; }, 300);
    },

    refresh: function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { CartDrawer.render(cart); })
        .catch(function() {
          var el = document.getElementById('dogal-drawer-items');
          if (el) el.innerHTML = '<p style="text-align:center;color:#999;padding:40px;font-size:13px;">Hata oluştu.</p>';
        });
    },

    render: function(cart) {
      var s = settings;
      var threshold = s.freeShippingThreshold || 1000;
      var remaining = threshold - (cart.total_price / 100);
      var pct = Math.min(100, (cart.total_price / 100 / threshold) * 100);

      var shippingEl = document.getElementById('dogal-drawer-shipping');
      if (shippingEl) {
        shippingEl.innerHTML = remaining > 0
          ? '<div style="padding:12px 20px;background:#fafafa;border-bottom:1px solid #f0f0f0;"><p style="font-size:11px;color:#555;margin:0 0 8px;">' + (s.freeShippingLabel || '').replace('{amount}', remaining.toFixed(2)) + '</p><div style="height:3px;background:#e5e5e5;border-radius:2px;"><div style="height:3px;background:#111;border-radius:2px;width:' + pct + '%;"></div></div></div>'
          : '<div style="padding:12px 20px;background:#f0faf4;border-bottom:1px solid #d4edda;display:flex;align-items:center;gap:8px;"><span style="color:#2a9d5c;">✓</span><span style="font-size:11px;color:#2a9d5c;font-weight:600;">' + (s.freeShippingSuccess || '') + '</span></div>';
      }

      var itemsEl = document.getElementById('dogal-drawer-items');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div style="text-align:center;padding:60px 20px;"><p style="font-size:13px;color:#999;margin:0 0 20px;">Sepetiniz boş.</p><a href="/collections/all" style="display:inline-block;padding:13px 28px;background:#111;color:#fff;font-size:11px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;text-decoration:none;">Alışverişe Başla</a></div>';
        var footerEl = document.getElementById('dogal-drawer-footer');
        if (footerEl) footerEl.innerHTML = '';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        html += '<div style="display:flex;gap:14px;padding:16px 20px;border-bottom:1px solid #f5f5f5;">' +
          '<a href="' + item.url + '" style="flex-shrink:0;"><img src="' + item.featured_image.url + '" style="width:72px;height:90px;object-fit:cover;" alt=""></a>' +
          '<div style="flex:1;min-width:0;">' +
            '<a href="' + item.url + '" style="font-size:11px;font-weight:700;color:#111;letter-spacing:0.06em;text-transform:uppercase;text-decoration:none;display:block;margin-bottom:4px;">' + item.product_title + '</a>' +
            '<p style="font-size:11px;color:#aaa;margin:0 0 14px;">' + item.variant_title + '</p>' +
            '<div style="display:flex;align-items:center;justify-content:space-between;">' +
              '<div style="display:flex;align-items:center;border:1px solid #e5e5e5;">' +
                '<button onclick="CartDrawer.updateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" style="width:30px;height:30px;background:none;border:none;cursor:pointer;font-size:16px;color:#111;">−</button>' +
                '<span style="width:30px;text-align:center;font-size:12px;font-weight:600;">' + item.quantity + '</span>' +
                '<button onclick="CartDrawer.updateQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" style="width:30px;height:30px;background:none;border:none;cursor:pointer;font-size:16px;color:#111;">+</button>' +
              '</div>' +
              '<span style="font-size:13px;font-weight:700;color:#111;">' + (item.final_line_price / 100).toFixed(2) + ' TL</span>' +
            '</div>' +
            '<button onclick="CartDrawer.updateQty(\'' + item.key + '\',0)" style="background:none;border:none;padding:0;margin-top:8px;font-size:10px;color:#bbb;cursor:pointer;text-decoration:underline;letter-spacing:0.1em;text-transform:uppercase;">Kaldır</button>' +
          '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;

      var cartHandles = cart.items.map(function(i) { return i.handle; });
      document.querySelectorAll('.dogal-suggested-item').forEach(function(el) {
        el.style.display = cartHandles.indexOf(el.getAttribute('data-handle')) !== -1 ? 'none' : 'flex';
      });

      var footerEl = document.getElementById('dogal-drawer-footer');
      if (footerEl) {
        footerEl.innerHTML =
          '<div style="padding:16px 20px;">' +
            '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:4px;">' +
              '<span style="font-size:11px;color:#aaa;letter-spacing:0.08em;text-transform:uppercase;">Ara Toplam</span>' +
              '<span style="font-size:16px;font-weight:700;color:#111;">' + (cart.total_price / 100).toFixed(2) + ' TL</span>' +
            '</div>' +
            '<p style="font-size:10px;color:#bbb;margin:0 0 14px;">KDV dahil, kargo hariç</p>' +
            '<a href="/checkout" style="display:block;padding:15px;background:#111;color:#fff;text-align:center;font-size:11px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;text-decoration:none;margin-bottom:8px;">' + (s.checkoutLabel || 'Ödemeye Geç') + '</a>' +
            '<a href="/cart" style="display:block;padding:11px;text-align:center;font-size:10px;font-weight:600;letter-spacing:0.16em;text-transform:uppercase;color:#aaa;text-decoration:none;">' + (s.cartLabel || 'Sepeti Görüntüle') + '</a>' +
          '</div>';
      }

      var c = document.querySelector('.cart-count');
      if (c) c.textContent = cart.item_count > 0 ? cart.item_count : '';
    },

    quickAdd: function(vid, btn) {
      btn.textContent = '...';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: vid, quantity: 1}) })
        .then(function(r) { return r.json(); })
        .then(function() { CartDrawer.refresh(); })
        .catch(function() { btn.textContent = '!'; btn.disabled = false; });
    },

    updateQty: function(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { CartDrawer.render(cart); });
    },

    toggleCoupon: function(btn) {
      var form = document.getElementById('dogal-coupon-form');
      var arrow = document.getElementById('dogal-coupon-arrow');
      if (!form) return;
      var isOpen = form.style.display === 'block';
      form.style.display = isOpen ? 'none' : 'block';
      if (arrow) arrow.textContent = isOpen ? '+' : '−';
    },

    applyCoupon: function() {
      var code = document.getElementById('dogal-coupon-input');
      if (!code || !code.value.trim()) return;
      window.location.href = '/checkout?discount=' + encodeURIComponent(code.value.trim());
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    init();
    document.querySelectorAll('a[href="/cart"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        CartDrawer.open();
      });
    });
  });
})();
